
import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { Card as ShadcnCard } from "@/components/ui/card";

interface CardProps extends React.ComponentPropsWithoutRef<typeof ShadcnCard> {
  isHoverable?: boolean;
  isGlass?: boolean;
  isElevated?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, isHoverable, isGlass, isElevated, children, ...props }, ref) => {
    return (
      <ShadcnCard
        ref={ref}
        className={cn(
          // Base styles with slight refinement
          "border overflow-hidden transition-all duration-300",
          
          // Hover animation
          isHoverable && "card-hover",
          
          // Glass morphism
          isGlass && "bg-white/80 backdrop-blur-md border border-white/40",
          
          // Elevation
          isElevated && "shadow-elevation",
          
          // Default shadow
          !isElevated && "shadow-subtle",
          
          // Passed class
          className
        )}
        {...props}
      >
        {children}
      </ShadcnCard>
    );
  }
);

Card.displayName = "Card";

// Re-export shadcn card subcomponents
export { CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
